import { KeyValueType } from '../models/common';

export const Genders: KeyValueType[] = [
  {
    key: 'Male',
    value: 'MALE',
  },
  {
    key: 'Female',
    value: 'FEMALE',
  },
  {
    key: 'Others',
    value: 'OTHER',
  },
];
export const MaritalStatuses: KeyValueType[] = [
  { key: 'Single', value: 'SINGLE' },
  { key: 'Married', value: 'MARRIED' },
  { key: 'Divorced', value: 'DIVORCED' },
  { key: 'Widowed', value: 'WIDOWED' },
  { key: 'Separated', value: 'SEPARATED' },
];
export const EmploymentStatuses: KeyValueType[] = [
  { key: 'Self Employed', value: 'SELF_EMPLOYED' },
  { key: 'Employed (Full-Time)', value: 'EMPLOYED_FULL_TIME' },
  { key: 'Employed (Part-Time)', value: 'EMPLOYED_PART_TIME' },
  { key: 'Employed (Casual)', value: 'EMPLOYED_CASUAL' },
  { key: 'Employed (Temporary)', value: 'EMPLOYED_TEMPORARY' },
  { key: 'Employed (Seasonal)', value: 'EMPLOYED_SEASONAL' },
];
export const Industries: KeyValueType[] = [
  { key: 'Agriculture', value: 'AGRICULTURE' },
  { key: 'Banking', value: 'BANKING' },
  { key: 'Construction', value: 'CONSTRUCTION' },
  { key: 'Education', value: 'EDUCATION' },
  { key: 'Energy', value: 'ENERGY' },
  { key: 'Government', value: 'GOVERNMENT' },
  { key: 'Healthcare', value: 'HEALTHCARE' },
  { key: 'Hospitality', value: 'HOSPITALITY' },
  { key: 'Insurance', value: 'INSURANCE' },
  { key: 'Manufacturing', value: 'MANUFACTURING' },
  { key: 'Media', value: 'MEDIA' },
  { key: 'Real Estate', value: 'REAL_ESTATE' },
  { key: 'Retail', value: 'RETAIL' },
  { key: 'Technology', value: 'TECHNOLOGY' },
  { key: 'Telecommunications', value: 'TELECOMMUNICATIONS' },
  { key: 'Transportation', value: 'TRANSPORTATION' },
  { key: 'Other', value: 'OTHER' },
];
export const LoanOfficerStatus: KeyValueType[] = [
  {
    key: 'Yes',
    value: 'YES',
  },
  {
    key: 'No',
    value: 'NO',
  },
];
export const ClientTypes: KeyValueType[] = [
  {
    key: 'Individual',
    value: 'INDIVIDUAL',
  },
  {
    key: 'Group',
    value: 'GROUP',
  },
];
export const ClientGroupRole: KeyValueType[] = [
  {
    key: 'Member',
    value: 'MEMBER',
  },
  {
    key: 'Leader',
    value: 'LEADER',
  },
  {
    key: 'Secretary',
    value: 'SECRETARY',
  },
  {
    key: 'Treasurer',
    value: 'TREASURER',
  },
];
export function getUserLanguages() {
  const Languages: KeyValueType[] = [
    {
      key: 'English',
      value: 'en',
    },
    {
      key: 'French',
      value: 'fr',
    },
    {
      key: 'German',
      value: 'de',
    },
    {
      key: 'Spanish',
      value: 'es',
    },
    {
      key: 'Portuguese',
      value: 'pt',
    },
    {
      key: 'Swahili',
      value: 'sw',
    },
  ];
  return Languages;
}


export const Designations: KeyValueType[] = [
  {
    key: $localize`:staff|label for staff@@staff_enum:Staff`,
    value: 'STAFF',
  },
  {
    key: $localize`:director|label for director@@director_enum:Director`,
    value: 'DIRECTOR',
  },
];

export const RelationshipTypes: KeyValueType[] = [
  {
    key: 'Brother',
    value: 'BROTHER',
  },
  {
    key: 'Sister',
    value: 'SISTER',
  },
  {
    key: 'Parent',
    value: 'PARENT',
  },
  {
    key: 'Father',
    value: 'FATHER',
  },
  {
    key: 'Mother',
    value: 'MOTHER',
  },
  {
    key: 'Uncle',
    value: 'UNCLE',
  },
  {
    key: 'Aunt',
    value: 'AUNT',
  },
  {
    key: 'Uncle',
    value: 'UNCLE',
  },
  {
    key: 'Nephew',
    value: 'NEPHEW',
  },
  {
    key: 'Nephew',
    value: 'NIECE',
  },
  {
    key: 'Cousin',
    value: 'COUSIN',
  },
  {
    key: 'Son',
    value: 'SON',
  },
  {
    key: 'Daughter',
    value: 'DAUGTHER',
  },
  {
    key: 'Spouse',
    value: 'SPOUSE',
  },
  {
    key: 'Friend',
    value: 'FRIEND',
  },
  {
    key: 'Sibling',
    value: 'SIBLING',
  },
  {
    key: 'Business Associate',
    value: 'BUSINESS_ASSOCIATE',
  },
  {
    key: 'Others',
    value: 'OTHERS',
  },
];

export const CorporateAffiliateRelationshipTypes: KeyValueType[] = [
  { key: 'Parent Company', value: 'PARENT_COMPANY' },
  { key: 'Subsidiary', value: 'SUBSIDIARY' },
  { key: 'Sister Company', value: 'SISTER_COMPANY' },
  { key: 'Holding Company', value: 'HOLDING_COMPANY' },
  { key: 'Joint Venture', value: 'JOINT_VENTURE' },
  { key: 'Associate', value: 'ASSOCIATE' },
  { key: 'Partner', value: 'PARTNER' },
  { key: 'Other', value: 'OTHER' },
];

export const CalendarUnit = [
  {
    label: 'Day',
    value: 'DAY',
  },
  {
    label: 'Week',
    value: 'WEEK',
  },
  {
    label: 'Month',
    value: 'MONTH',
  },
  {
    label: 'Year',
    value: 'YEAR',
  },
];
